import { render, staticRenderFns } from "./formData.vue?vue&type=template&id=787a4fef"
import script from "./formData.vue?vue&type=script&lang=js"
export * from "./formData.vue?vue&type=script&lang=js"
import style0 from "./formData.vue?vue&type=style&index=0&id=787a4fef&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports